
import React, { useState, useEffect } from 'react'
import { API_BASE_URL, PRODUCT_DOWNLOD_EXCEL, PRODUCT_UPLOAD_EXCEL, GET_STORE, GET_USER_STORES, PRODUCT_EDIT_DOWNLOD_EXCEL, PRODUCT_EDIT_UPLOAD_EXCEL } from '../..//Config';
import Axios from "axios";
// import { Link } from 'react-router-dom';
import Select from "react-select";


const ProductExcels = () => {

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedEditFile, setSelectedEditFile] = useState(null);

    const [userDataSession, setUserDataSession] = useState([]);
    const [mainStoreId, setMainStoreId] = useState(0);
    const [storesData, setStoresData] = useState([]);
    const [selectedStore, setSelectedStore] = useState(null);
    const [selectedAddFileName, setSelectedAddFileName] = useState(null); 
    const [selectedEditFileName, setSelectedEditFileName] = useState(null); 
    const [addDownloadExcelLoading, setEditDownloadExcelLoading] = useState(false);
    const [editDownloadExcelLoading, setAddDownloadExcelLoading] = useState(false);

    const [addUploadExcelLoading, setAddUploadExcelLoading] = useState(false);
    const [editUploadExcelLoading, setEditUploadExcelLoading] = useState(false);

    // const fileInputRef = React.useRef(null);
    const addFileInputRef = React.useRef(null);
    const editFileInputRef = React.useRef(null);
    // const [loading, setLoading] = useState(false);

    const [offcanvasWidth, setOffcanvasWidth] = useState("45%");

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setOffcanvasWidth("75%");
            } else {
                setOffcanvasWidth("45%");
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if(userDataSession && userDataSession.OrgId) {
          console.log('headders user stores service fetching....');
          Axios.get(`${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`)
            .then(response => {
                if (response.data) {
                  setStoresData(response.data.ResultData);
                } else {
                    console.error('Error fetching data:', response.data);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
          }
      }, [userDataSession]);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
          Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
            .then((response) => {
              if (response.data.Status) {
                const storesData = response.data.ResultData;
                const mainStore = storesData.find(
                  (store) => store.IsMainStore === true
                );
                if (mainStore) {
                  setMainStoreId(mainStore.Id);
                  console.log(
                    `Main Store ID: ${mainStore.Id}, Name: ${mainStore.Name}`
                  );
                } else {
                  console.log("No main store found");
                }
              } else {
                console.error("Error fetching data:", response.data);
              }
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        }
    }, [userDataSession]);
    const storeOptions = Array.isArray(storesData)
        ? storesData.map((store) => ({
            value: store.StoreId,
            label: store.Name,
        }))
        : [];  

    const handleAddDownloadExcel = (e) => {
        e.preventDefault();
        setAddDownloadExcelLoading(true);
        const link = document.createElement('a');
        link.href = `${API_BASE_URL}${PRODUCT_DOWNLOD_EXCEL}?OrgId=${userDataSession.OrgId}`;
        
        link.download = 'ADDProducts.xlsx';
        document.body.appendChild(link);
        setAddDownloadExcelLoading(false);
        link.click();
        document.body.removeChild(link);
        setAddDownloadExcelLoading(false);
    };

    const handleAddImageClick = () => {
        addFileInputRef.current.click();
    };

    const handleAddFileChange = (event) => {
        const file = event.target.files[0];
        console.log(event.target.files, 'file selected');
        console.log(file.name, 'name name name')
        if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel')) {
            setSelectedFile(file);
        } else {
            alert('Please select a valid Excel file.');
        }
    };

    const handleAddUploadExcel = async (e) => {
        e.preventDefault();
    
        if (!selectedFile) {
            alert('Please select a file first.');
            return;
        }
        if (!mainStoreId) {
          alert('Main store could not be found. Please try again later or contact support.');
          return;
        }  

        setAddUploadExcelLoading(true);
    
        const formData = new FormData();
        formData.append('orgid', userDataSession.OrgId);
        formData.append('userid', userDataSession.UserId);
        formData.append('StoreId', mainStoreId);
        formData.append('file', selectedFile);
    
        try {
            // Log the formData content
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
    
            const response = await fetch(`${API_BASE_URL}${PRODUCT_UPLOAD_EXCEL}`, {
                method: 'POST',
                body: formData,
            });
    
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setAddUploadExcelLoading(false);
                alert('File uploaded successfully');
                window.location.reload();
            } else {
                alert('File upload failed');
                setAddUploadExcelLoading(false);
                console.error('Upload failed', response.statusText);
            }
        } catch (error) {
            setAddUploadExcelLoading(false);
            console.error('Error uploading file', error);
            alert('Error uploading file');
        }
    };

    const handleStoreChange = (selectedOption) => {
        setSelectedStore(selectedOption);
        console.log(selectedOption)
    };

    // const handleEditDownloadExcel = (e) => {
    //     e.preventDefault();
    //     if (!selectedStore) {
    //         alert('Please select store first..');
    //     }
    //     else {
    //         const link = document.createElement('a');
    //         link.href = `${API_BASE_URL}${PRODUCT_EDIT_DOWNLOD_EXCEL}?OrgId=${userDataSession.OrgId}&StoreId=${selectedStore.value}`;
        
    //         link.download = 'filename.xlsx';
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //     }
    // };
    

    const handleEditDownloadExcel = async (e) => {
        e.preventDefault();
        setEditDownloadExcelLoading(true);
        if (!selectedStore) { 
            alert('Please select Store');
            return;
        }
        const storeId = selectedStore ? selectedStore.value : mainStoreId;
    
        if (!storeId) {
            alert('Please select a store first or ensure isMainstoreId is available.');
        } else {
            const downloadUrl = `${API_BASE_URL}${PRODUCT_EDIT_DOWNLOD_EXCEL}?OrgId=${userDataSession.OrgId}&StoreId=${storeId}`;
    
            try {
                const response = await fetch(downloadUrl);
    
                // Log the response status to inspect the response from the server
                console.log('Response Status:', response.status, response.statusText);
                
                if (response.status === 404) {
                    alert('No products found for this selected store.');
                    setEditDownloadExcelLoading(false);
                    return;
                }
    
                if (!response.ok) {
                    setEditDownloadExcelLoading(false);
                    throw new Error(`Failed to fetch the file. Status: ${response.statusText}`);
                }
    
                // If response is ok and a file is present, handle blob download
                const blob = await response.blob();
    
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'EDITProducts.xlsx';
    
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setEditDownloadExcelLoading(false);
            } catch (error) {
                setEditDownloadExcelLoading(false);
                console.error('Error during download:', error);
                alert(`An error occurred: ${error.message}`);
            }
        }
    };
    

    const handleEditImageClick = () => {
        editFileInputRef.current.click();
    };

    const handleEditFileChange = (event) => {
        const file = event.target.files[0];
        if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel')) {
            setSelectedEditFile(file);
        } else {
            alert('Please select a valid Excel file.');
        }
    };

    useEffect(() => {
        if (selectedFile) {
            console.log(selectedFile)
            setSelectedAddFileName(selectedFile?.name);
            setSelectedEditFileName('');
        }
    }, [selectedFile]);

    useEffect(() => {
        if (selectedEditFile) {
            setSelectedEditFileName(selectedEditFile?.name);
            setSelectedAddFileName('');
        }
    }, [selectedEditFile]);

    const handleEditUploadExcel = async (e) => {
        e.preventDefault();
        setEditUploadExcelLoading(true);
    
        if (!selectedEditFile) {
            alert('Please select a file first.');
            return;
        }
        if (!mainStoreId) {
          alert('Main store could not be found. Please try again later or contact support.');
          return;
        }  
    
        const formData = new FormData();
        formData.append('orgid', userDataSession.OrgId);
        formData.append('userid', userDataSession.UserId);
        formData.append('StoreId', selectedStore.value);
        formData.append('file', selectedEditFile);
    
        try {
            // Log the formData content
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
    
            const response = await fetch(`${API_BASE_URL}${PRODUCT_EDIT_UPLOAD_EXCEL}`, {
                method: 'POST',
                body: formData,
            });
    
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setEditUploadExcelLoading(false);
                alert('File uploaded successfully');
                window.location.reload();
            } else {
                alert('File upload failed');
                setEditUploadExcelLoading(false);
                console.error('Upload failed', response.statusText);
            }
        } catch (error) {
            setEditUploadExcelLoading(false);
            console.error('Error uploading file', error);
            alert('Error uploading file');
        }
    };

        return (
            <div>
                <div
                    className={`offcanvas offcanvas-end`}
                    tabIndex={-1}
                    id="offcanvasRight"
                    aria-labelledby="offcanvasRightLabel"
                    style={{ maxWidth: offcanvasWidth }}
                >
                    <div className="offcanvas-header">
                        <h4 id="offcanvasRightLabel" className={`${[1, 2, 4].includes(userDataSession.RoleId) ? '' : 'd-none'}`}>Import Products</h4>
                        <button
                            type="button"
                            className="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        />
                    </div> <hr/>
                    <div className="offcanvas-body">
                        <div className={`col-12 ${[1, 2, 4].includes(userDataSession.RoleId) ? '' : 'd-none'}`}>
                            <table>
                                <tbody>
                                    <tr>
                                        <th className='text-primary' style={{ verticalAlign: 'top' }}>Step1: </th>
                                        <td></td>
                                        <td className='ms-4' style={{ verticalAlign: 'top' }}>
                                            Download the product data template. <br />
                                            Use this file to format and modify the product details you want to upload.
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='text-primary' style={{ verticalAlign: 'top' }}>Step2: </th>
                                        <td></td>
                                        <td className='ms-4' style={{ verticalAlign: 'top' }}>
                                            After preparing your data, please upload the Excel file using the form below.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {addDownloadExcelLoading || addUploadExcelLoading ? <div className='m-auto loader'></div> :
                            <div className={`mb-5 ${[1, 2, 4].includes(userDataSession.RoleId) ? '' : 'd-none'}`}>
                                <div className='d-flex justify-content-end align-items-center'>
                                    <p className='mb-0'>Download Template</p>
                                    <button 
                                        className='btn d-flex'
                                        title="Download template" 
                                        onClick={handleAddDownloadExcel}
                                    >
                                        <i className="fa-solid fa-download text-danger fs-4"></i>
                                    </button>
                                </div>
                                <div className="drag-drop text-center">
                                    <div className="upload" onClick={handleAddImageClick}>
                                        <a href="#"><img src="assets/img/icons/drag-drop.svg" style={{ width: '3rem' }} alt="Drag and drop"/></a>
                                        <p>
                                            {selectedAddFileName ? (
                                                <>
                                                    Selected file: <span className="text-primary fw-bold">{selectedAddFileName}</span>
                                                </>
                                            ) : (
                                                <>
                                                    Choose a <a href="#">file to upload.</a>
                                                </>
                                            )}
                                        </p>
                                    </div>
                                    <input 
                                        type="file"
                                        style={{ display: 'none' }}
                                        ref={addFileInputRef}
                                        onChange={handleAddFileChange}
                                        accept=".xls, .xlsx"
                                    />
                                </div>
                                <button
                                    className='btn btn-success d-flex ms-auto mt-2'
                                    onClick={handleAddUploadExcel}
                                >Submit
                                </button>
                            </div>
                        }

                        <hr className={`${[1, 2, 4].includes(userDataSession.RoleId) ? '' : 'd-none'}`} />

                        <h4>Manage Products</h4>
                        <div className="col-12 mt-2">
                            <table>
                                <tbody>
                                    <tr>
                                        <th className='text-primary' style={{ verticalAlign: 'top' }}>Step1: </th>
                                        <td></td>
                                        <td className='ms-4' style={{ verticalAlign: 'top' }}>In this step, you can download the template file to prepare your product data.</td>
                                    </tr>
                                    <tr>
                                        <th className='text-primary' style={{ verticalAlign: 'top' }}>Step2: </th>
                                        <td></td>
                                        <td className='ms-4' style={{ verticalAlign: 'top' }}>
                                            Download the product data template. <br />
                                            Use this file to format and modify the product details you want to upload.
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='text-primary' style={{ verticalAlign: 'top' }}>Step3: </th>
                                        <td></td>
                                        <td className='ms-4' style={{ verticalAlign: 'top' }}>
                                            After preparing your data, please upload the Excel file using the form below.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {editDownloadExcelLoading || editUploadExcelLoading ? <div className='m-auto loader'></div> :
                            <div className='mb-5'>
                                <div className='d-flex justify-content-end align-items-center'>
                                    <p className='mb-0'>Download Template</p>
                                    <button 
                                        className='btn d-flex'
                                        title="Download template" 
                                        onClick={handleEditDownloadExcel}
                                    >
                                        <i className="fa-solid fa-download text-danger fs-4"></i>
                                    </button>
                                </div>
                                <div className="col-lg-8 col-sm-6 col-12">
                                    <label>Store</label>
                                    <div className="input-bloks">
                                    <Select
                                        className="select"
                                        id="storeSelect"
                                        onChange={handleStoreChange}
                                        options={storeOptions}
                                        placeholder="Choose store"
                                    />
                                    </div>
                                </div>
                                <div className="drag-drop text-center mt-4">
                                    <div className="upload" onClick={handleEditImageClick}>
                                        <a href="#"><img src="assets/img/icons/drag-drop.svg" style={{ width: '3rem' }} alt="Drag and drop"/></a>
                                        <p>
                                            {selectedEditFileName ? (
                                                <>
                                                    Selected file: <span className="text-primary fw-bold">{selectedEditFileName}</span>
                                                </>
                                            ) : (
                                                <>
                                                    Choose a <a href="#">file to upload.</a>
                                                </>
                                            )}
                                        </p>
                                    </div>
                                    <input 
                                        type="file"
                                        style={{ display: 'none' }}
                                        ref={editFileInputRef}
                                        onChange={handleEditFileChange}
                                        accept=".xls, .xlsx"
                                    />
                                </div>
                                <button
                                    className='btn btn-success d-flex ms-auto mt-2'
                                    onClick={handleEditUploadExcel}
                                >Submit
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
}

export default ProductExcels
